export enum TaskTemplatePriorityEnum {
  Low,
  Medium,
  High
}

export const TaskTemplatePriorityStringEnum = {
  Low: 'Low',
  Medium: 'Medium',
  High: 'High'
};

export enum TaskTriggerTypeEnum {
  Manual,
  Automatic
}

export enum TaskTriggerTypeStringEnum {
  Manual = 'Manual',
  Automatic = 'Automatic'
}

